export const environmentBase = {
    paymenttoken: `Ykr3AFRHzDBFfnrP+dRoX++prJJQ/RKRh2CjJhQK4Z7l4UZ0n3fn6z
    y7Ew+OSg1BXkNjlJkvK3FfYibNq7U0v9OGnIPG8z32ns+2ezG+TY5dPkA+eUVkzqyYn3KpKBEdv`,
	Termsandcondition: 'https://paced.s3.amazonaws.com/ASSETS/TERMS/PACED_Terms_Conditions.docx',
	//Termsandcondition: 'https://s3.amazonaws.com/paced/ASSETS/TERMS/PACED_Terms_Conditions.docx',
    name: 'PACED',
    ManuallyEnterInfoId: 'A649031',
    version: '1.0.0.0',
	PACEDHometest: 'https://testwww.acep.org/paced/',
	PACEDHomeprod: 'https://www.acep.org/PACED/'

};



// WEBPACK FOOTER //
// C:/AZURE/ACEP/Acep.Crm.WebPortal/CrmWebPortalGlobal/Membership/AngularApps/PACED/PACEDAngular/src/environments/environment.base.ts